import axios from 'axios';

const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

export interface AirQualityData {
  aqi: number;
  components: {
    co: number;
    no: number;
    no2: number;
    o3: number;
    so2: number;
    pm2_5: number;
    pm10: number;
    nh3: number;
  };
  timestamp: string;
  location: string;
}

class AirQualityService {
  private static instance: AirQualityService;

  static getInstance(): AirQualityService {
    if (!AirQualityService.instance) {
      AirQualityService.instance = new AirQualityService();
    }
    return AirQualityService.instance;
  }

  async getAirQuality(lat: number = 12.9716, lon: number = 77.5946): Promise<AirQualityData | null> {
    try {
      const response = await axios.get('https://api.openweathermap.org/data/2.5/air_pollution', {
        params: {
          lat,
          lon,
          appid: WEATHER_API_KEY
        }
      });

      const data = response.data.list[0];
      return {
        aqi: data.main.aqi,
        components: data.components,
        timestamp: new Date(data.dt * 1000).toISOString(),
        location: 'Current Location'
      };
    } catch (error) {
      console.error('Error fetching air quality:', error);
      return null;
    }
  }
}

export default AirQualityService.getInstance();